export * from "@/ui/components/navigation/Tabs/Tabs";
export * from "@/ui/components/navigation/Tabs/Tabs.config";
export * from "@/ui/components/navigation/Tabs/TabsContent";
export * from "@/ui/components/navigation/Tabs/TabsList";
export * from "@/ui/components/navigation/Tabs/TabsLinks";
export * from "@/ui/components/navigation/Tabs/TabsRoot";
export * from "@/ui/components/navigation/Tabs/TabsTrigger";
export * from "@/ui/components/navigation/Tabs/TabsTriggers";
